// Simple wrapper around browser fetch for SWR
import fetch from 'cross-fetch'
import { spektrixApiUrl, fetchOptions } from './config'

const SpektrixFetcher = url => {
  // Named expansion of only the basket collections the frontend reads, with
  // tickets/event nested so meal-deal detection can still read ticket.event.name
  // (basket-model consumers read it directly off this response). Replaces the
  // depth-3 form, which dragged in every collection plus the deep
  // ticket -> instance -> event -> venue tree.
  const fullUrl =
    url === '/basket'
      ? `${url}?$expand=tickets/event,donations,membershipSubscriptions,merchandiseItems,giftVouchers`
      : url
  return fetch(`${spektrixApiUrl}${fullUrl}`, fetchOptions).then(res => res.json())
}

export default SpektrixFetcher
